import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import { PreRegisterFormValues } from 'utilities/resources/formItemValues'

const SceneComponent: React.FC = () => {
  const location = useLocation()
  const formValues = (location.state as PreRegisterFormValues) ?? {
    email: 'mail@example.com',
  }
  return (
    <>
      <Header title="メール送信完了" />
      <main>
        <section className="mx-4 my-5">
          <div>
            <p>{formValues.email}</p>
            <p className="fw-bold">メールが送信されました</p>
          </div>
          <div className="mt-5">
            <p>ご登録のメールアドレスにパスワード再登録フォームの案内メールを送信しました。</p>
            <p>10分以内にメールに記載されているリンクをクリックし、新しいパスワードを登録してください。</p>
            <p>案内メールが届かない場合、迷惑メールフォルダに振り分けられている可能性があります。</p>
          </div>
          <div className="mt-4">
            <Button variant="primary" className="w-100 py-4" href={'/login'}>
              ログイン画面へ戻る
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
